export default {
  playerPage: {
    errorTitle: 'Une erreur est survenue lors de la lecture de la partition. Ce problème peut survenir si une autre application utilisant du son (ex: Youtube) est en cours d\'exécution en parallèle avec Tokatab. Veuillez redémarrer l\'application. Si le problème persiste, contactez le support.',
    restartButton: 'Redémarrer l\'application',
    songUnavailable: 'Désolé, cette chanson ne semble pas disponible pour le moment. Veuillez réessayer plus tard.',
    backToHome: 'Retour à la home',
    exerciseLabel: 'EXERCICE',
  },
  
  playerHeaderBar: {
    exitTutorial: 'Quitter le tutoriel',
    learningMode: 'Mode apprentissage',
    partitionUnavailable: 'Partition indisponible',
    pieces: 'Morceaux',
    challenges: 'Challenges',
    pedagogicalPath: 'Parcours Pédagogique',
    levelEvaluation: 'Evaluation de votre niveau',
    exercise: 'Exercice',
    step: 'Etape'
  },
  
  playerControlsBar: {
    exitTutorial: 'Quitter',
    listenCarefully: 'Écoutez attentivement, voici la partie que nous allons étudier.',
    demo: 'Démo',
    skip: 'Passer',
    finish: 'Terminer',
    display: 'Affichage'
  },
  
  validationModal: {
    title: 'Comment avez-vous trouvé',
    difficulties: {
      veryHard: 'Trop difficile',
      hard: 'Difficile',
      adapted: 'Adapté',
      easy: 'Facile',
      veryEasy: 'Trop facile'
    },
    revisionMessage: 'D\'accord, je prends en compte votre retour !',
    backToHome: 'Retourner à l\'accueil',
    continue: 'Continuer',
    modifyChoice: 'Modifier mon choix',
    calculatingProgress: 'Mise à jour de votre progression',
    
    // Feedback texts for difficulty level 5 (too hard)
    veryHardResponses: {
      response1: 'Ok ! Nous le retravaillerons plus tard lorsqu\'il sera plus facile.',
      response2: 'D\'accord ! Nous le retravaillerons alors.',
      response3: 'C\'est noté ! Je vais tenir compte de ce retour pour mes futures recommandations.',
      response4: 'Entendu ! Nous le rejouerons en temps voulu.'
    },
    
    // Feedback texts for difficulty level 4 (hard)
    hardResponses: {
      response1: 'Je note ! Vous verrez, nous le réviserons plus tard et il vous paraîtra plus facile.',
      response2: 'Bravo pour votre ténacité ! Je prévois de vous le faire réviser plus tard.',
      response3: 'C\'est souvent en se confrontant à la difficulté que l\'on progresse ! D\'ici quelques semaines, cet exercice vous paraîtra plus facile.',
      response4: 'Entendu ! Nous le retravaillerons plus tard.'
    },
    
    // Feedback texts for difficulty level 3 (adapted)
    adaptedResponses: {
      response1: 'Entendu ! Nous le réviserons peut être une fois ou deux.',
      response2: 'Super ! Nous le rejouerons une fois ou deux dans quelques temps.',
      response3: 'OK ! Je tiens compte de ce retour pour mes futures recommandations.',
      response4: 'D\'accord ! Je note qu\'il nécessitera peu de révisions.'
    },
    
    // Feedback texts for difficulty level 2 (easy)
    easyResponses: {
      response1: 'D\'accord ! Dans ce cas, je considère que ce ne sera pas la peine de le réviser.',
      response2: 'Super ! Je considère que vous le maîtrisez à 100%.',
      response3: 'Super ! Je sens que nous allons vite progresser ensemble.',
      response4: 'Ok ! Si c\'est facile pour vous, alors cela signifie que ce ne sera pas la peine de le réviser.'
    },
    
    // Feedback texts for difficulty level 1 (too easy)
    veryEasyResponses: {
      response1: 'D\'accord ! Je vais tenir compte de ce retour.',
      response2: 'Ok ! Je considère que vous le maîtrisez à 100% et qu\'il ne sera pas nécessaire de le réviser.',
      response3: 'Super ! Il ne sera donc pas nécessaire de le réviser plus tard.',
      response4: 'Ok ! Si c\'est très facile pour vous, alors je vais en tenir compte.'
    },

    loadingTexts: {
      text1: "Je prends en compte votre jeu et vos retours…",
      text2: "Je mets à jour votre progression…",
      text3: "Je prépare la suite…",
      text4: "J'affine vos prochaines recommandations…",
      text5: "Je finalise les derniers réglages…",
      text6: "C'est presque prêt…"
    }
  },
  
  evaluationModal: {
    title: 'C\'était comment ?',
    fail: {
      label: 'C\'était difficile',
      subLabel: 'Essayons encore',
      success: 'Essayons encore'
    },
    good: {
      label: 'J\'y arrive bien',
      subLabel: 'Continuer',
      success: 'Oh yeah !'
    },
    easy: {
      label: 'Trop facile !',
      success: 'Oh Yeah!'
    },
    yourScore: 'Votre score :',
    congratulations: 'Bravo, vous pouvez passer à l\'étape suivante !',
    restart: 'Recommencer',
    continue: 'Continuer',
    keepWorking: 'Travaillons encore cette partie pour atteindre les 90%.',
    skip: 'Passer',
    finalizingEvaluation: 'Finalisation de votre évaluation...',
    mayTakeMoment: 'Cela peut prendre quelques instants.'
  },
  
  successModal: {
    defaultTitle: 'Génial !',
    continue: 'Continuer',
    home: 'Accueil'
  },
  
  skillUpdateComponent: {
    title: 'Progrès dans vos compétences',
    loading: 'Chargement des compétences...',
    error: 'Une erreur est survenue lors du chargement des compétences.',
    error2: "Si l'erreur persiste, veuillez contacter le support."
  },
  
  successRecommandations: {
    title: 'Voici ce que je vous propose maintenant',
    challengeLabel: 'Appliquer vos compétences musicalement avec un challenge',
    continueSkill: 'Continuer à travailler la compétence',
    startNewSkill: 'Commencer à travailler une nouvelle compétence',
    workSomethingElse: 'Travailler autre chose'
  },
  
  playerView: {
    listeningActive: 'Écoute en cours'
  },
  
  bigSuccessComponent: {
    defaultTitle: 'Mission Accomplie'
  },
  
  audioCaptureButton: {
    activate: 'Activer le mode écoute',
    deactivate: 'Désactiver le mode écoute',
    modalTitle: 'Mode écoute',
    explanationPart1: 'Tout au long de votre parcours en cliquant sur le bouton',
    explanationPart2: 'vous activerez le "mode écoute".',
    explanationPart3: 'Le son de Tokatab est alors coupé pour ne pas brouiller les fréquences captées par le micro.',
    doNotShowAgain: 'Ne plus afficher',
    continue: 'Continuer',
    
    microphoneAccessTitle: 'Mode écoute',
    microphoneAccessMessage: 'Vous avez refusé l\'accès au micro. Si vous souhaitez utiliser le "mode écoute", il faut autoriser l\'accès à votre micro :',
    privacyMessage: 'Nous tenons à respecter votre vie privée, les enregistrements restent sur votre appareil et ne sont pas sauvegardés !',
    close: 'Fermer',
    activateListening: 'Activer mode écoute',
    
    mustAllowMicrophone: 'Vous devez autoriser le micro pour pouvoir utiliser le mode écoute',
    notCompatible: 'Le mode écoute n\'est pas compatible avec votre appareil',
    listeningActivated: 'J\'ai activé l\'écoute de vos notes, je désactive le son pour bien vous entendre.',
    listeningDeactivated: 'J\'ai désactivé le mode écoute.',
    activationError: 'Erreur lors de l\'activation du mode écoute, réessayez'
  },
  
  playerKaraokeTimeline: {
    lyricsInRhythm: 'Paroles en rythme',
    lyricsInText: 'Paroles en texte'
  },
  
  challengeController: {
    contentType: 'ce challenge'
  },
  
  sectionExerciseController: {
    contentType: 'cet exercice'
  },
  
  playerSongClassViewController: {
    incredible: 'Incroyable !',
    bravo: 'Bravo !',
    great: 'Génial !',
    juryDescription: 'Si j\'avais été dans le jury je me serais retourné ! Vous êtes maintenant prêt à partir en tournée',
    goToSinging: 'Passer au chant',
    courseMenu: 'Menu du cours',
    nextStepHint: 'Prochaine étape',
    nextSingHint: 'Commencer le chant',
    nextFullPieceHint: 'Morceau complet',
    readyForFullPiece: 'Vous maîtrisez les enchainements ! Passez maintenant au morceau complet avant de chanter.',
    demonstration: 'Démonstration',
    readyToSing: 'Vous êtes maintenant prêt à vous entraîner à chanter ce morceau',
    readyToShowOff: 'Génial ! Vous êtes prêt pour vous la péter au piano',
    masterParts: 'Vous maîtrisez la partie {partName}, vous pouvez maintenant vous concentrer sur une autre partie.',
    masterSection: 'Vous maîtrisez la section {sectionName}, vous pouvez maintenant vous concentrer sur les autres sections.',
    firstStepNotification: 'Vous êtes à la première étape du cours, il est impossible de revenir en arrière.'
  },
  
  abstractPlayerSuggestionController: {
    scoreMessages: {
      veryLow: 'Aïe aïe aïe, votre score est de',
      low: 'Pas mal ! Votre score est de',
      medium: 'Encore un petit effort ! Votre score est de',
      high: 'Super !  Votre score est de',
      perfect: 'Parfait ! Très impressionnant, vous n\'avez fait aucune fausse note. Votre score est de 100% !'
    },
    actions: {
      restart: 'Recommencer',
      validate: 'Valider',
      slower: 'Essayer plus lentement',
      faster: 'Augmenter le tempo',
      activate: 'Activer',
      previousStep: 'Revenir à l\'étape précédente'
    }
  },
  
  suggestionController: {
    goodWorkFaster: 'On dirait que vous avez bien travaillé ! Pourquoi ne pas essayer à un tempo plus rapide ?',
    goodWorkFasterNow: 'On dirait que vous avez bien travaillé ! Passons à un tempo plus rapide !',
    validateChallenge: 'Validons ce challenge !',
    nextStep: 'Passons à l\'étape suivante !',
    nextExercise: 'Passons à l\'exercice suivant !',
    readyValidateChallenge: 'Prêt à valider ce challenge ?',
    readyNextStep: 'Prêt à passer à l\'étape de cours suivante ?',
    readyNextExercise: 'Prêt à passer à l\'exercice suivant ?',
    trySlower: 'Peut-être devriez-vous essayer avec un tempo plus lent ?',
    challengeNotAdapted: 'Ce challenge n\'est peut être pas encore adapté à votre niveau.',
    memorize: 'Parfois, il vaut mieux prendre le temps de bien mémoriser l\'étape précédente !',
    needMoreTime: 'Il est normal d\'avoir parfois besoin de plus de temps !',
    wellPlayed: 'Bien joué. Souhaitez-vous accelérer ?',
    wellPlayedValidate: 'Bien joué. Souhaitez-vous valider ?',
    fasterThanMusic: 'Vous allez plus vite que la musique ! Souhaitez-vous valider ?',
    oneMoreRound: 'Encore un tour et on passe à la suite ?',
    setupMidi: 'Pour profiter pleinement de Tokatab, connectez votre piano MIDI ou configurez votre microphone.',
    setupButton: 'Configurer',
    acquiredPiano: 'Avez-vous acquis un piano ? Pour profiter pleinement de Tokatab, connectez votre piano ou configurez votre microphone.',
    setupPianoButton: 'Configurer mon piano',
    activateListening: 'Pour que je puisse vous aider, activez le mode écoute ou connectez votre piano.'
  },
  
  playerTimerController: {
    restart: 'Recommencer',
    next: 'Suivant',
    nextStep: 'Prochaine étape'
  },
  
  loadingTimeline: {
    loading: 'Chargement du contenu...'
  },
  
  playerPartitionTimeline: {
    loadingError: 'Erreur de chargement de la partition'
  },
  
  loopParameters: {
    types: {
      none: 'Aucune',
      play: 'Tout',
      part: 'Partie',
      section: 'Section',
      rhythmicBloc: 'Rythmique',
      list: 'Enchainement'
    }
  },
  
  visualParameters: {
    handLabels: {
      leftHand: 'la main gauche',
      rightHand: 'la main droite',
      bothHands: 'mains ensemble'
    },
    timelineLabels: {
      left: 'Main Gauche',
      right: 'Main Droite',
      lyrics: 'Paroles'
    }
  },

  soundParameters: {
    soundLabels: {
      main: 'Global',
      leftHand: 'Main Gauche',
      rightHand: 'Main Droite',
      melody: 'Mélodie',
      metronome: 'Métronome'
    } 
  },
  
  playerControllers: {
    congratulations: 'Félicitations !',
    close: 'Fermer',
    continue: 'Continuer',
    validate: 'Valider',
    faster: 'Plus rapide',
    slower: 'Plus lent',
    previousStep: 'Etape précédente',
    letsGo: 'C\'est parti !',
    tooHard: 'C\'est trop dur',
    youKnowHowToPlay: 'Vous savez maintenant jouer',
    backToClassMenu: 'Retour au menu de cours',
    tutorialComplete: 'Vous avez terminé le tutoriel !',
    onHomePage: 'Sur la page d\'accueil, vous trouverez des missions à remplir pour vous familiariser avec l\'application.',
    discoverApp: 'Continuer',
    restart: 'Recommencer !',
    evaluationComplete: 'Vous avez terminé l\'évaluation !'
  },
  
  loopSelector: {
    repetition: 'Répétition'
  },
  
  tempoController: {
    slow: 'Lent',
    medium: 'Moyen',
    normal: 'Normal',
    pass100Percent: 'Passer à 100%'
  },
  
  timelineVisibilityButtons: {
    sheetMusicNotAvailable: 'La partition n\'est pas disponible pour ce contenu.',
    textFeedback: 'Retour textuelle',
    hide: 'Masquer',
    show: 'Afficher',
    fingers: 'Doigtés',
    notes: 'Notes',
    fingersAndNotes: 'Doigtés et Notes',
    leftHand: 'Main Gauche',
    rightHand: 'Main Droite',
    lyrics: 'Paroles'
  },
  
  timelineVisibilitySwitch: {
    hide: 'Masquer',
    show: 'Afficher'
  },
  
  metronomeSwitch: {
    activate: 'Activer le métronome',
    deactivate: 'Désactiver le métronome',
    metronome: 'Métronome'
  },
  
  soundController: {
    volumes: 'Volumes',
    activateSound: 'J\'active le son de la {soundType}',
    deactivateSound: 'Je désactive le son de la {soundType}',
    focusOnLearning: 'pour que vous vous concentriez sur ce que vous allez apprendre.',
    familiarizeWithSinging: 'que cette partie piano accompagne.',
    familiarizeWithPlaying: 'pour que vous vous familiarisiez avec ce que vous allez jouer plus tard.',
    leftHand: 'main gauche',
    rightHand: 'main droite',
    melody: 'mélodie',
    main: 'global',
    metronome: 'metronome',
    soundLabels: {
      main: 'Global',
      leftHand: 'Main Gauche',
      rightHand: 'Main Droite',
      melody: 'Mélodie',
      metronome: 'Metronome'
    }
  },
  
  volumeSwitch: {
    mute: 'Couper',
    activate: 'Activer',
    sound: 'le son'
  },
  
  welcomeModalHeaderButton: {
    back: 'Retour'
  },
  
  playerChallengeController: {
    quit: 'Quitter le challenge',
    backHome: 'Retourner à l\'accueil',
    home: 'Accueil',
    back: 'Retour',
    alreadyValidated: 'Vous avez déjà validé ce challenge',
    mustPlayAt100: 'Il faut réussir à jouer cet extrait à tempo 100% pour le valider.',
    toFinishChallenge: 'Pour terminer ce challenge il faut jouer <b>{handConfig}</b> à <b>100%</b> du tempo cible !',
    presentTokatab1: 'Je vous propose de découvrir comment jouer avec Tokatab grâce à un challenge “Tuto”.',
    presentTokatab2: 'Les challenges sont de petits extraits pratiques pour réviser et appliquer vos compétences au piano.',
    presentTokatab3: 'Comme tous les contenus proposés dans l’application, il faudra réussir cet extrait à tempo 100 % pour le valider.',
    tooComplex: 'Si le challenge est trop complexe pour vous, vous pouvez essayer à une vitesse plus lente !'
  },
  
  exerciseInfoPanel: {
    mainCompetence: 'Compétence principale',
    otherSkills: 'Autres compétences',
    videos: 'Vidéos à revoir',
    watched: 'Vue',
    noContent: 'Aucun détail disponible pour cet exercice.',
    quit: "Quitter l'exercice",
  },

  playerSectionExerciseController: {
    backToLessons: 'Retour aux leçons',
    nextExercise: 'Exercice suivant',
    backHome: 'Retourner à l\'accueil',
    home: 'Accueil',
    back: 'Retour',
    next: 'Suivant',
    alreadyValidated: 'Vous avez déjà validé cet exercice',
    alreadyValidated2: ", mais comme vous l'aviez trouvé difficile, nous vous proposons de le retravailler",
    whatIFind: 'Ce que je retrouve dans cet exercice',
    skills: 'Compétences',
    data: 'Données',
    skillsIFind: 'Dans cet exercice, voici les compétences que nous allons travailler ensemble',
    handprintsList: 'Liste des empreintes de l\'exercice',
    rhythmicsList: 'Liste des rythmiques de l\'exercice',
    revisionIntro: 'Vous avez validé cet exercice le {date}{difficulty}. Révisons le !',
    difficulties: {
      veryEasy: 'très facile',
      easy: 'facile',
      adapted: 'adapté',
      hard: 'difficile',
      veryHard: 'très difficile'
    },
    foundItPrefix: ' et l\'aviez trouvé ',
    tooComplex: 'Si l\'exercice est trop complexe pour vous, vous pouvez essayer à une vitesse plus lente !',
    listExerciseHandprints: 'Liste des empreintes de l\'exercice'
  },
  
  playerSongViewController: {
    congratulations: 'Félicitations !',
    youKnowHowToPlay: 'Vous savez maintenant jouer',
    close: 'Fermer',
    alreadyStarted: 'Vous avez déjà commencé le cours sur ce morceau !',
    wantToContinue: 'Voulez vous reprendre sa progression ?',
    finished: 'Vous avez terminé le cours de ce morceau !',
    whatToDo: 'Que voulez-vous faire ?',
    notStarted: 'Vous n\'avez pas encore commencé le cours de ce morceau. Souhaitez-vous de l\'aide pour l\'apprendre ?',
    play: 'Jouer',
    learnAlone: 'J\'apprends seul',
    learnWithTeacher: 'J\'apprends avec le prof',
    reviewCourse: 'Revoir le cours',
    resumeCourse: 'Reprendre le cours',
    pieces: 'Morceaux'
  },
  
  playerEvaluationController: {
    congratulations: 'Félicitations !',
    successDescription: 'Vous avez réussi ce défi',
    nextStep: 'Prochaine étape',
    evaluationCompleteSubtitle: 'Vous avez terminé l\'évaluation !',
    personalizedPathDescription: 'Vous pouvez maintenant accéder à votre parcours pédagogique personnalisé ! Et progresser facilement en suivant les exercices proposés',
    restart: 'Recommencer',
    additionalTries: '2 tentatives supplémentaires',
    finishEvaluation: 'Terminez l\'évaluation',
    yourLevel: 'Votre niveau :',
    home: 'Accueil',
    levelEvaluationTitle: 'Evaluation de votre niveau',
    needPiano: 'Vous aurez besoin d\'un piano pour effectuer ce test.',
    challengeIntro: 'Je vais vous proposer une série de petits défis de plus en plus difficiles. Nous arrêterons votre test dès que l\'un de ces défis <b>vous semblera trop compliqué !</b> Pas d\'inquiétude si cela devient difficile rapidement : je serai là par la suite pour vous faire découvrir et travailler les bases ainsi que les notions qui vous manquent.',
    threeTries: 'Pour chaque défi, vous aurez droit à <b>3 tentatives</b> pour le jouer parfaitement.',
    finishTestAccess: '<b>Terminez le test</b> pour accéder à votre parcours pédagogique personnalisé !',
    threeTriesReminder: 'Pour rappel, vous aurez droit à <b>3 tentatives</b> par exercice. Alors concentrez vous bien !',
    doItLater: 'Je le ferai plus tard',
    start: 'Commencer',
    resume: 'Reprendre',
    finishLater: 'finir plus tard',
    fingerReminder: 'Rappel sur les doigtés',
    challenge: 'Défi :',
    letsGo: 'C\'est parti !',
    thisStep: 'cette étape',
    cantDoIt: 'Vous n\'y arrivez plus ? Souhaitez vous terminer ici le test ?',
    noTryAgain: 'Non, j\'essaye encore',
    yesFinish: 'Oui, finir le test',
    step: 'Etape',
    additionalTriesNotification: 'Vous avez exceptionnellement deux tentatives supplémentaires pour réussir cette étape ! Cliquez sur le bouton play quand vous vous sentez prêt !',
    triesRemaining: 'Il vous reste {count} essai(s) ! Cliquez sur le bouton play quand vous vous sentez prêt !',
    tooHard: "Trop dur"
  },
  
  evaluationSuggestionController: {
    trialsRemaining: 'Il vous reste {count} essai(s) pour valider {name} !'
  },

  playerLoader: {
    loading: 'Analyse de vos dernières progressions en cours. Cela peut prendre quelques instants, merci de patienter.'
  }
};
